import { render, staticRenderFns } from "./paySupport.vue?vue&type=template&id=2fb6fd72&scoped=true"
import script from "./paySupport.vue?vue&type=script&lang=js"
export * from "./paySupport.vue?vue&type=script&lang=js"
import style0 from "./paySupport.vue?vue&type=style&index=0&id=2fb6fd72&prod&lang=scss&scoped=true"
import style1 from "./paySupport.vue?vue&type=style&index=1&id=2fb6fd72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb6fd72",
  null
  
)

export default component.exports